<template>
    <div id="program">
  <!--    Mobil-->
  <div
    class="h-auto mx-auto flex flex-col md:hidden"
    style="background-color: #FBFBFB"
  >
    <div class="w-full mt-16 max-w-7xl mx-auto">
      <h1
        class="text-4xl font-semibold mx-6 my-10"
      >
        {{ title }}
      </h1>
    </div>
    <div class="max-w-7xl w-full mx-auto flex flex-col">
      <div class="mx-6 mb-6">
        <Accordion
          v-for="day in days"
          class="my-6"
        >
          <template #title v-for="d in day">
            <span class="text-xl pb-3 flex items-center hover:text-success">{{ d.day }}</span>
          </template>
          <template #content>
            <div
              v-for="d in day"
              class="mb-5"
            >
              <p class="mt-2 flex items-center text-gray-500">
                <svg
                  width="12"
                  height="12"
                  class="mr-2"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 3.66667V6L7.75 7.75M11.25 6C11.25 8.8995 8.8995 11.25 6 11.25C3.10051 11.25 0.75 8.8995 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75C8.8995 0.75 11.25 3.10051 11.25 6Z"
                    stroke="#01798A"
                    stroke-width="1.16667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {{ d.start }} - {{ d.end }}
              </p>
              <p class="text-lg">
                <strong>{{ d.name }}</strong>
              </p>
            </div>
          </template>
        </Accordion>
      </div>
    </div>
  </div>
  <!--Desktop-->
  <div
    class="hidden h-auto mx-auto md:flex"
    style="background-color: #FBFBFB"
  >
    <div class="max-w-7xl w-full py-20 mx-auto flex">
      <div class="w-1/3">
        <h1
          class="text-2xl font-semibold my-20 ml-14 mr-6 lg:text-4xl lg:my-14"
        >
          {{ title }}
        </h1>
      </div>
      <div class="w-2/3 mx-auto flex flex-col">
        <div class="mt-7 mr-14 py-3">
          <Accordion
            v-for="day in days"
            class="my-3"
          >
            <template #title v-for="d in day">
              <span class="text-xl mb-3">{{ d.day }}</span>
            </template>
            <template #content>
              <div
                v-for="d in day"
                class="my-8"
              >
                <p class="mt-2 flex items-center text-gray-500">
                  <svg
                    width="12"
                    height="12"
                    class="mr-2"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 3.66667V6L7.75 7.75M11.25 6C11.25 8.8995 8.8995 11.25 6 11.25C3.10051 11.25 0.75 8.8995 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75C8.8995 0.75 11.25 3.10051 11.25 6Z"
                      stroke="#01798A"
                      stroke-width="1.16667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {{ d.start }} - {{ d.end }}
                </p>
                <p class="text-lg">
                  <strong>{{ d.name }}</strong>
                </p>
              </div>
            </template>
          </Accordion>
        </div>
      </div>
    </div>
  </div>
    </div>
</template>

<script setup>
import Accordion from '@/ComponentsDeprecated/Accordion/Accordion'

const props = defineProps({
  program: {
    type: Array,
    required: true
  },
  title: {
    type: String,
    required: true,
    default: '',
  }
})

const activity = props.program.filter(activity => activity.type === 'activity')
const eatery = props.program.filter(activity => activity.type === 'eatery')
let programs = activity.concat(eatery)

const lookup = programs.reduce((acc, item) => {
  const exists = acc.some(i => i === item.start)
  return exists ? acc : [...acc, item.start];
}, []);

const grouped = programs.reduce((acc, item) => {
  const date = new Date(item.start).toLocaleTimeString([], { day: '2-digit', month: '2-digit', year: '2-digit' })
  const group = date.split(',')[0]

  if (!acc[group]) {
    acc[group] = [];
  }
  acc[group].push(item);
  return acc;
}, {});

const days = Object.values(grouped).map((array) =>
  array.map((o) => ({
      day: new Date(o.start).toLocaleTimeString([], { weekday:'long', day: '2-digit', month: '2-digit', year: '2-digit' }).split(',')[0],
      start: new Date(o.start).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).split('T')[0],
      end: new Date(o.end).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).split('T')[0],
      name: o.name
  }))
)

</script>
